export default __webpack_public_path__ + "static/media/esports2.63497188.jpg";